module.exports = __webpack_public_path__ + "static/media/twitter.56348f28.svg";